function cardSlider() {
    if ($('.jsCardSlider').length > 0) {
        var $cardSlider = $('.jsCardSlider');
        $cardSlider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            responsive: [ 
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 890,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });
    }
}
function reviewSlider() {
    if ($('.jsReviewSlider').length > 0) {
        var $reviewSlider = $('.jsReviewSlider');
        $reviewSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: $(".slick-arrow--prev"),
            nextArrow: $(".slick-arrow--next"),
            responsive: [ 
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
}
function blogSlider() {
    if ($('.jsBlogSlider').length > 0) {
        var $blogSlider = $('.jsBlogSlider');
        $blogSlider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            responsive: [ 
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 890,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });
    }
}
$(document).ready(function() {
  cardSlider();
  reviewSlider();
  blogSlider();
});

/* Product review star click - Scroll */
var starsElement = document.querySelector('.yotpo-bottomline .yotpo-stars');
if(starsElement){
starsElement.onclick = function() {
    starsElement.style.background = 'red';
    window.location.href = '#prodReviews';
};
}

